<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<style>
  #app{
    height: 100%;
  }
</style>
<script>
export default {
}
</script>

